import { useCallback, useEffect, useState } from "react";

export function useMatchMedia(query: string): boolean | undefined {
  const [matches, setMatches] = useState<boolean | undefined>(undefined);

  const changeHandler = useCallback((event: MediaQueryListEvent) => {
    setMatches(event.matches);
  }, []);

  useEffect(() => {
    const mediaQueryList = window.matchMedia(query);
    setMatches(mediaQueryList.matches);
    mediaQueryList.addEventListener("change", changeHandler);
    return () => {
      mediaQueryList.removeEventListener("change", changeHandler);
    };
  }, [changeHandler, query]);
  return matches;
}
